import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { getFeatureSwitches } from '@/api/featureSwitches/getFeatureSwitches';
import type { Feature } from '@/@types/featureSwitch';

export const useGetFeatureSwitches = () => {
  const { isLoading, isFetching, data, isError } = useQuery({
    queryKey: ['feature-switches'],
    queryFn: getFeatureSwitches,
  });

  return {
    initializing: isLoading || isFetching || isError,
    isFetching,
    isLoading: isLoading || isFetching,
    isError,
    features: data?.features,
  };
};

export const useFeature = (feature: Feature): boolean => {
  const { initializing, features } = useGetFeatureSwitches();
  const searchParams = new URLSearchParams(window.location.search);

  const isExperimentEnabled = searchParams.getAll('experiment').includes(feature);

  const featureMap = useMemo(() => {
    if (initializing || !features) return {};
    return Object.fromEntries(features.map((f) => [f.feature, f.enabled]));
  }, [initializing, features]);

  return isExperimentEnabled || !!featureMap[feature];
};
